import { isMerchantWideType } from '@/config/agentCards'
import { AGENT_DAILY_SEND_CAP, DEFAULT_AGENT_TYPE } from '@/view/ai/agentTypes'

export const blankAgentForm = () => ({
  type: DEFAULT_AGENT_TYPE,
  belongs_to_id: '',
  is_active: true,
  trigger_time_value: '',
  trigger_time_type: 'minutes',
  offer_enabled: false,
  discount_code_id: '',
  review: {
    order_threshold: 3,
    google_review_link: '',
    checkin_template: ''
  },
  winback: {
    send_cap: AGENT_DAILY_SEND_CAP,
    reactivation_window_days: 30,
    slipping: {
      enabled: true,
      offer_enabled: false,
      discount_code_id: '',
      outreach_template: '',
      gap_multiplier: 1.5,
      min_orders: 3,
      frequency_cooldown_days: 30
    },
    lost: {
      enabled: true,
      offer_enabled: false,
      discount_code_id: '',
      outreach_template: '',
      lost_window_days: 90,
      retouch_cooldown_days: 120
    }
  }
})

export const buildAgentPayload = (form, { outreachContent = '', outreachStepId = null, playbookId = null } = {}) => {
  const playbookAttrs = { is_active: form.is_active }
  if (!isMerchantWideType(form.type)) {
    playbookAttrs.belongs_to_class = 'Store'
    playbookAttrs.belongs_to_id = form.belongs_to_id
  }
  if (playbookId) playbookAttrs.id = playbookId

  if (form.type === 'UpsellAgent' || form.type === 'AbandonCartAgent') {
    playbookAttrs.trigger_time_value = form.trigger_time_value
    playbookAttrs.trigger_time_type = form.trigger_time_type

    if (outreachContent) {
      const step = {
        step_style: 'outreach',
        content: outreachContent,
        is_verbatim: true,
        is_required: true
      }
      if (outreachStepId) step.id = outreachStepId
      playbookAttrs.agent_playbook_steps_attributes = [step]
    }
  }

  if (form.type === 'AbandonCartAgent') {
    playbookAttrs.raw_context = {
      offer_enabled: form.offer_enabled,
      discount_code_id: form.discount_code_id
    }
  }

  if (form.type === 'ReviewAgent') {
    playbookAttrs.raw_context = {
      order_threshold: Number(form.review.order_threshold) || 3,
      google_review_link: form.review.google_review_link,
      checkin_template: form.review.checkin_template
    }
  }

  if (form.type === 'WinbackAgent') {
    playbookAttrs.raw_context = {
      send_cap: Number(form.winback.send_cap) || AGENT_DAILY_SEND_CAP,
      reactivation_window_days: Number(form.winback.reactivation_window_days) || 30,
      slipping: {
        ...form.winback.slipping,
        gap_multiplier: Number(form.winback.slipping.gap_multiplier) || 1.5,
        min_orders: Number(form.winback.slipping.min_orders) || 3,
        frequency_cooldown_days: Number(form.winback.slipping.frequency_cooldown_days) || 30
      },
      lost: {
        ...form.winback.lost,
        lost_window_days: Number(form.winback.lost.lost_window_days) || 90,
        retouch_cooldown_days: Number(form.winback.lost.retouch_cooldown_days) || 120
      }
    }
  }

  return {
    agent: {
      type: form.type,
      is_active: form.is_active,
      agent_playbook_attributes: playbookAttrs
    }
  }
}
